import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledTableHeader = styled.div `
    display: none;

    @media only screen and (min-width: 992px) {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 18px 10px;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: ${color.body.base};
    }
`;
const TableHeader = ({ children, className }) => (_jsx(StyledTableHeader, { className: className, children: children }));
export default TableHeader;
